import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { GetAllExpeditionBoResponseDtoExpedition } from "@/types/api/api-types";
import { useUpdateExpeditionBo } from "@/api/expedition.api";
import { SelectV2 } from "@/components/ui/customs/select-v2";
import { ExpeditionBlockedReasonEnum } from "@/constants/enums/expeditionBlockedReason.enum";
import { useExpeditionBlockedReasonOptions } from "@/hooks/useEnumOptions";

export const BlockedReasonSelect = ({
  expedition,
}: {
  expedition: GetAllExpeditionBoResponseDtoExpedition;
}) => {
  const { t } = useTranslation("boExpeditions");
  const blockedReasonOptions = useExpeditionBlockedReasonOptions();
  const { mutateAsync: updateExpeditionBo } = useUpdateExpeditionBo();

  const handleChange = useCallback(
    async (value: string) => {
      const blockedReason = value as ExpeditionBlockedReasonEnum;
      await updateExpeditionBo({ id: expedition.id, payload: { blockedReason } });
    },
    [expedition.id, updateExpeditionBo],
  );

  return (
    <SelectV2
      value={expedition.blockedReason || ""}
      onChange={handleChange}
      options={blockedReasonOptions}
      placeholder={t("blockedReasonSelect.placeholder")}
      wrapperClassName="gap-0"
    />
  );
};
